import {
  Control,
  Icon,
  IconText,
  A,
  Input,
  Navbar,
  NavbarEnd,
  NavbarItem,
  Subtitle,
  Title,
  Div,
} from "trunx";
import {
  IconDefinition,
  faBars,
  faBookmark,
  faCloudRain,
  faCloudSunRain,
  faLayerGroup,
  faSearch,
  faTape,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IPanel } from "./models/Menus";
import { LangSelect } from "./shared/LangSelect";
import config from "./config";
import { faCircle } from "@fortawesome/free-regular-svg-icons";
import { observer } from "mobx-react-lite";
import { useLocaleContext } from "./contexts/LocaleContext";
import { useRootStore } from "./models/Root";

const Navbar_ = () => {
  const {
    dict: { nav: dict, panel: panelDict },
  } = useLocaleContext();

  const {
    menus: { toggleNav, setFind, find, togglePanel },
    layers,
    isMobile,
  } = useRootStore();

  const PanelLink = ({
    panel,
    icon,
  }: {
    panel: IPanel;
    icon: IconDefinition;
  }) => (
    <A bulma="navbar-item" onClick={() => togglePanel(panel)}>
      <IconText>
        <Icon>
          <FontAwesomeIcon icon={icon} />
        </Icon>
        <span>{panelDict[panel].title}</span>
      </IconText>
    </A>
  );

  if (isMobile) {
    return (
      <Navbar style={{ zIndex: 1000 }}>
        <A bulma="navbar-item" onClick={toggleNav}>
          <Icon style={{ width: "30px" }}>
            <FontAwesomeIcon icon={faBars} />
          </Icon>
        </A>

        <NavbarItem>
          <Control hasIconsRight>
            <Input
              id="find"
              bulma="has-background-dark"
              placeholder={dict.search}
              onChange={(e) => setFind(e.target.value)}
              value={find}
              type="search"
              autoComplete="off"
            ></Input>

            <Icon className={"is-right"}>
              <FontAwesomeIcon icon={faSearch} />
            </Icon>
          </Control>
        </NavbarItem>
        <NavbarItem className="mobile-title">
          <Subtitle>{config.title}</Subtitle>
        </NavbarItem>
      </Navbar>
    );
  }

  return (
    <Navbar style={{ zIndex: 1000 }}>
      <A bulma="navbar-item" onClick={toggleNav}>
        <Icon>
          <FontAwesomeIcon icon={faBars} />
        </Icon>
      </A>
      <NavbarItem bulma="has-dropdown" className="navbar-title-search">
        <Div bulma="level">
          <Div bulma="level-left">
            <Div bulma="level-item">
              <Title>{config.title}</Title>
            </Div>
            <Div bulma="level-item">
              <Control hasIconsRight>
                <Input
                  bulma="has-background-dark"
                  placeholder={dict.search}
                  onChange={(e) => setFind(e.target.value)}
                  value={find}
                ></Input>
                <Icon className={"is-right"}>
                  <FontAwesomeIcon icon={faSearch} />
                </Icon>
              </Control>
            </Div>
          </Div>
        </Div>
      </NavbarItem>
      <PanelLink panel="sensors" icon={faCircle} />
      {layers.any && <PanelLink panel="layers" icon={faLayerGroup} />}
      {config.radar && <PanelLink panel="radar" icon={faCloudRain} />}
      {config.forecast && (
        <PanelLink panel="forecast" icon={faCloudSunRain} />
      )}
      <PanelLink panel="bookmarks" icon={faBookmark} />
      <PanelLink panel="measure" icon={faTape} />
      <NavbarEnd>
        <A bulma="navbar-item">
          <LangSelect />
        </A>
      </NavbarEnd>
    </Navbar>
  );
};

export default observer(Navbar_);
